import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  hint?: string;
  'data-test-id'?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, type, error, hint, 'data-test-id': dataTestId, ...props },
    ref
  ) => {
    return (
      <div className="space-y-1" data-test-id="input-wrapper">
        <input
          type={type}
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            error && 'border-destructive focus-visible:ring-destructive',
            className
          )}
          ref={ref}
          data-test-id={dataTestId || 'input'}
          {...props}
        />
        {error && (
          <p className="text-sm text-destructive" data-test-id="input-error">
            {error}
          </p>
        )}
        {hint && !error && (
          <p
            className="text-sm text-muted-foreground"
            data-test-id="input-hint"
          >
            {hint}
          </p>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
